export enum UserApiRoutes {
  Search = '/users',
  BulkAssign = '/users/bulk-assign',
  ById = '/users/:id',
  Managers = '/users/retention-managers',
  RetentionAgents = '/users/retention-agents',
  ByRoleKey = '/users/role',
  Mine = '/users/mine',
  Roles = '/users/:id/roles',
  Features = '/users/:id/features',
  UserSession = '/api/user',
  UserById = '/users/:id/masterAgentId',
}
